<template lang="html">
  <div class="contactZone" v-if="startup.key_contact_name || startup.key_contact_email || startup.website">
    <div class="mb20 dflexcontact">
      <div class="contactIcon"><v-icon icon="mdi:mdi-account-circle-outline" /></div>
      <div class="">
        <h5><strong>Key contact</strong></h5>
        <span class="contactInfo_kcn" v-if="startup.key_contact_name">{{startup.key_contact_name}}</span>
      </div>

    </div>

      <ul class="contactInfoList">
        <li class="contactInfoItem" v-if="startup.key_contact_email">
          <a :href="'mailto:'+startup.key_contact_email">{{startup.key_contact_email}}</a>
        </li>
        <li class="contactInfoItem" v-if="startup.key_contact_phone">
          <a :href="'tel:'+startup.key_contact_phone">{{startup.key_contact_phone}}</a>
        </li>
        <li class="contactInfoItem" v-if="startup.website">
          <a :href="website_formated" target="_blank">{{ getBaseUrl(startup.website) }}</a>
        </li>

      </ul>
  </div>
</template>

<script>
export default {
  name : "StartupContact",
  props: ["startup"],
  components: {
  },
  data() {

  },
  computed:{
    website_formated: function(){
      if(this.startup.website){
        if(this.startup.website.startsWith("https://") || this.startup.website.startsWith("http://")){
          return this.startup.website;
        }
        else{
          return "https://"+this.startup.website;
        }
      }
      else{
        return null;
      }

    },
  },
  methods:{

    getBaseUrl(u){
      if(u){
        var formated = u.replace(/^https?:\/\//, '').replace(/\/$/, '');
        try{
          var r= new URL(u).origin;
          r = r.replace(/^https?:\/\//, '').replace(/\/$/, '');
          return r;
        }catch{
          return formated;
        }
      }
      else{
        return "";
      }

    },
  }
}
</script>

<style lang="css" scoped>
.contactZone{
  border:2px solid #125AA4;
  background:#125AA4;
  border-radius: 10px;
  padding:20px 20px;
  width:auto;
  position:relative;
}
.contactZone h5{
  display: block;
  color: #fff !important;
  margin-bottom: 0;
  font-size:22px;
}

.dflexcontact {
  display: flex;
  gap: 10px;
  align-items: center;
}
.mb20 {
  margin-bottom: 20px;
}
.contactInfo_kcn{
  color: #FFF;
  font-weight: 600;
  font-size: 18px;
}
.contactInfoItem {
  color: #B38D2F !important;
}

.contactInfoItem{
  margin-bottom: 10px;


}
.contactInfoItem a, .contactInfoItem a:hover, .contactInfoItem span {
  color: #FFF !important;
}
.contactInfoItem * {
  word-break: break-all;
}
.contactIcon i {
  font-size: 30px;
  background: #3584C6;
  padding: 25px;
  color: #FFF;
  border-radius: 50%;
}
</style>
